import React, { useState } from "react";
import { useFormData } from "Contexts/FormDataContext";
import { useSession } from "Contexts/SessionContext";
import usePageContextUpdate from "Hooks/usePageContextUpdate";
import useSessionNavigate from "Hooks/useSessionNavigate";
import FormContentWrapper from "Components/FormContentWrapper";
import { NameFormContent, NameInfoContent } from "Components/NamePage";
import SessionLoading from "Components/SessionLoading";
import { getPageNumber, getPageSlug } from "Data";

const NamePage = () => {
  const { currentPageData, setSubmitted } = usePageContextUpdate();

  const {
    updateUserName,
    currentFormData: { userFirstName, userLastName, userEmail },
  } = useFormData();

  const {
    createSession,
    sessionCode,
    updateSession,
    sessionData,
    setIsLoading: setSessionLoading,
  } = useSession();
  const { sessionNavigate } = useSessionNavigate();
  const [isSubmitting, setIsSubmitting] = useState(false);

  const handleSubmit = async (data) => {
    if (isSubmitting) return;

    setIsSubmitting(true);
    setSessionLoading(true);

    try {
      updateUserName(data.firstName, data.lastName, data.email);

      let currentSessionCode = sessionCode;

      if (!sessionCode) {
        const contactData = {
          firstname: data.firstName,
          lastname: data.lastName,
          email: data.email,
        };

        const sessionResult = await createSession(contactData);

        if (sessionResult.success) {
          currentSessionCode = sessionResult.sessionCode;

          if (sessionResult.isExisting && sessionResult.currentPage > 1) {
            const lastPageSlug = getPageSlug(sessionResult.currentPage);
            sessionNavigate(`/form/${lastPageSlug}`, currentSessionCode);
            return;
          }
        }
      }

      if (currentSessionCode) {
        await updateSession(
          {
            current_page: getPageNumber("name-success"),
            responses: {
              ...sessionData?.responses,
              q1_basic_info: {
                firstname: data.firstName,
                lastname: data.lastName,
                email: data.email,
              },
            },
          },
          currentSessionCode,
        );
      }

      setSubmitted(true);
    } catch (error) {
      console.error("[NamePage] Error during submission:", error);
      setSubmitted(true);
    } finally {
      setIsSubmitting(false);
      setSessionLoading(false);
    }
  };

  if (isSubmitting) {
    return <SessionLoading />;
  }

  return (
    <FormContentWrapper
      infoContent={
        <NameInfoContent
          heading={currentPageData?.pageTitle || "No Heading Provided"}
        />
      }
      formFieldContent={
        <NameFormContent
          submitCB={handleSubmit}
          firstName={userFirstName}
          lastName={userLastName}
          email={userEmail}
        />
      }
    />
  );
};

export default NamePage;
